/**
 * Reproduz vídeo no hover dos cards de produto (desktop apenas).
 */
class CardProductVideo {
  static DESKTOP_QUERY = '(min-width: 990px)';

  constructor() {
    this.desktopMedia = window.matchMedia(CardProductVideo.DESKTOP_QUERY);
    this.init();
    this.desktopMedia.addEventListener('change', () => this.init());
    document.addEventListener('shopify:section:load', () => this.init());
  }

  isDesktop() {
    return this.desktopMedia.matches;
  }

  init() {
    document.querySelectorAll('.card-product-secondary-video').forEach((element) => {
      if (element.dataset.cardVideoInit === 'true') return;
      element.dataset.cardVideoInit = 'true';

      const cardWrapper = element.closest('.card-wrapper');
      if (!cardWrapper) return;

      const iframe = element.tagName === 'IFRAME' ? element : element.querySelector('iframe');
      const video = element.tagName === 'VIDEO' ? element : element.querySelector('video');

      if (iframe) {
        this.initExternalVideo(cardWrapper, iframe);
      } else if (video) {
        this.initNativeVideo(cardWrapper, video);
      }
    });
  }

  initNativeVideo(cardWrapper, video) {
    video.pause();
    video.currentTime = 0;

    const play = () => {
      if (!this.isDesktop()) return;
      const start = () => {
        video.play().catch(() => {});
      };
      if (video.readyState >= 2) {
        start();
      } else {
        video.addEventListener('loadedmetadata', start, { once: true });
      }
    };

    const pause = () => {
      video.pause();
      video.currentTime = 0;
    };

    cardWrapper.addEventListener('mouseenter', play);
    cardWrapper.addEventListener('mouseleave', pause);

    video.addEventListener('loadedmetadata', () => {
      video.pause();
      video.currentTime = 0;
    });
  }

  initExternalVideo(cardWrapper, iframe) {
    const videoSrc = iframe.dataset.videoSrc;
    if (!videoSrc) return;

    const play = () => {
      if (!this.isDesktop()) return;
      if (!iframe.src) {
        iframe.src = videoSrc;
      }
    };

    const pause = () => {
      iframe.src = '';
    };

    cardWrapper.addEventListener('mouseenter', play);
    cardWrapper.addEventListener('mouseleave', pause);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new CardProductVideo();
  });
} else {
  new CardProductVideo();
}
